import moment from 'moment'
import {KTSVG} from '../../../../_metronic/helpers'
import {WSSelect} from '../../../../_metronic/helpers/components/WSSelect/WSSelect'
import {storeReportId, storeSchedulerId} from '../reports-analytics/reportSlices/reportAnalytics'
import {useDispatch} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import {useEffect, useMemo, useState} from 'react'
import {FrontendDashboardActivity} from './FrontEndDashboardSlice/FrontendDashboardSlice'
import InsertNewData from '../../../Components/InsertNewData'
import {toast} from 'react-toastify'
import {fetchAsyncUserDetails} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
import Spinner from '../../../Components/Spinner'
import {
  useCancelCampaignMutation,
  useLazyGetAllCampaignListReportQuery,
} from '../../../../services/cellcast'
import {
  usePauseCampaignMutation,
  useResumeCampaignMutation,
  useCancelCampaignMutation as useCancelSendingCampaignMutation,
} from '../../../../services/cellcast.v2'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'

const DashbaordTablePage = ({className, whereWhen}: any) => {
  const API_URL = ENV().REACT_APP_API_URL
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [campType, setCampType] = useState('sms')
  let options: any = [
    {value: 'sms', label: 'SMS'},
    {value: 'mms', label: 'MMS'},
  ]

  const [refetch, {data, isFetching}] = useLazyGetAllCampaignListReportQuery()

  useEffect(() => {
    refetch({
      fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
      toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
      camp_type: campType,
      dashboardApi: true,
    })
  }, [campType])

  const [isOpenConfirmation, setIsOpenConfirmation] = useState(false)
  const [cancelParam, setCancelParam] = useState<{
    id: string
    staggerMessages: boolean
    staggerId: null | string
    type: string
  } | null>(null)

  // cancel
  const [isOpenCancelConfirmation, setIsOpenCancelConfirmation] = useState(false)
  const [cancelIdParam, setCancelIdParam] = useState('')
  const [cancelSendingMessage, {isLoading: cancelCampaignLoading}] =
    useCancelSendingCampaignMutation()

  // pause
  const [isOpenPauseConfirmation, setIsOpenPauseConfirmation] = useState(false)
  const [pauseIdParam, setPauseIdParam] = useState('')
  const [pauseSendingMessage, {isLoading: pauseCampaignLoading}] = usePauseCampaignMutation()

  // resume
  const [isOpenResumeConfirmation, setIsOpenResumeConfirmation] = useState(false)
  const [resumeIdParam, setResumeIdParam] = useState('')
  const [resumeSendingMessage, {isLoading: resumeCampaignLoading}] = useResumeCampaignMutation()

  // campaignType
  const [campaignType, setCampaignType] = useState('')

  const [selectedBulk, setSelectedBulk] = useState<{interval?: number; scheduleAt?: number} | null>(
    null
  )

  const getDisplayStatus = (key: any) => {
    if (key?.cancelledAt || key?.canceledAt) {
      return 'Canceled'
    }
    if (key?.pausedAt) {
      return 'Paused'
    }
    if (key?.finalStatus !== 'In Progress') {
      return key?.finalStatus
    }

    return 'In Progress'
  }

  const cancelConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenConfirmation}
        handleClose={() => {
          setIsOpenConfirmation(false)
          setCancelParam(null)
        }}
        Message={'Are you sure, you want to cancel the campaign ?'}
        confirm={() => {
          if (cancelParam) {
            handleCancelCampaign(cancelParam.id, cancelParam.staggerMessages, cancelParam.staggerId)
            setCancelParam(null)
          }
        }}
        confirmBtnTitle='Yes, cancel campaign'
      />
    ),
    [isOpenConfirmation, cancelParam]
  )

  const cancelSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenCancelConfirmation}
        handleClose={() => {
          setIsOpenCancelConfirmation(false)
          setCancelIdParam('')
        }}
        Message={'Are you sure, you want to cancel this campaign ?'}
        confirm={() => {
          if (cancelIdParam) {
            cancelSendingMessage({
              bulkId: cancelIdParam,
              type: campaignType,
            })
              .then((res: any) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error cancel campaign :', res.error)
                }
              })
              .catch((err: any) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenCancelConfirmation(false)
                setCancelIdParam('')
                setCampaignType('')
                refetch({
                  fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
                  toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
                  camp_type: campType,
                  dashboardApi: true,
                })
              })
          }
        }}
        confirmBtnTitle='Yes, cancel campaign'
      />
    ),
    [isOpenCancelConfirmation, cancelIdParam, cancelSendingMessage]
  )

  const pauseSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenPauseConfirmation}
        handleClose={() => {
          setIsOpenPauseConfirmation(false)
          setPauseIdParam('')
        }}
        Message={'Are you sure, you want to pause this campaign ?'}
        confirm={() => {
          if (pauseIdParam) {
            pauseSendingMessage({
              bulkId: pauseIdParam,
              type: campaignType,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error pause campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenPauseConfirmation(false)
                setPauseIdParam('')
                setCampaignType('')
                refetch({
                  fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
                  toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
                  camp_type: campType,
                  dashboardApi: true,
                })
              })
          }
        }}
        confirmBtnTitle='Yes, pause campaign'
      />
    ),
    [isOpenPauseConfirmation, pauseIdParam, pauseSendingMessage]
  )

  const resumeSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenResumeConfirmation}
        handleClose={() => {
          setIsOpenResumeConfirmation(false)
          setResumeIdParam('')
          setSelectedBulk(null)
        }}
        selectedBulk={selectedBulk}
        withIntervalConfirmation={true}
        Message={'Do you want to resume this campaign, please select an option below?'}
        confirm={({interval, scheduleAt}: {interval: number; scheduleAt: string}) => {
          if (resumeIdParam) {
            resumeSendingMessage({
              bulkId: resumeIdParam,
              type: campaignType,
              interval,
              scheduleAt: scheduleAt ? moment(scheduleAt).unix() : 0,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error resume campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenResumeConfirmation(false)
                setResumeIdParam('')
                setCampaignType('')
                setSelectedBulk(null)
                refetch({
                  fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
                  toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
                  camp_type: campType,
                  dashboardApi: true,
                })
              })
          }
        }}
        confirmBtnTitle='Yes, resume campaign'
      />
    ),
    [isOpenResumeConfirmation, resumeIdParam, resumeSendingMessage]
  )

  const [cancelCampaign, {isLoading: cancelLoading}] = useCancelCampaignMutation()

  const handleCancelCampaign = (
    id: string,
    staggerMessages: boolean = false,
    staggerId: null | string = null
  ) => {
    cancelCampaign({id, staggerId, staggerMessages})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          dispatch(fetchAsyncUserDetails())
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign:', res.error)
        }
      })
      .finally(() => {
        refetch({
          fromDate: moment(whereWhen?.start).format('YYYY-MM-DD'),
          toDate: moment(whereWhen?.end).format('YYYY-MM-DD'),
          camp_type: campType,
          dashboardApi: true,
        })
      })
  }

  return (
    <>
      {cancelConfirmation}
      {cancelSendingMessageConfirmation}
      {pauseSendingMessageConfirmation}
      {resumeSendingMessageConfirmation}
      <div className='col-12 mt-5'>
        <div className={`card ${className}`}>
          {/* begin::Header */}
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-3 mb-1'>Recent Campaigns </span>
              <span className='text-muted fw-light fs-7'>ordered by the most recent</span>
            </h3>
            <div className='card-toolbar'>
              <div className='nav-item pe-3 mb-1'>
                <form
                  data-kt-search-element='form'
                  className='w-100 mw-250px position-relative'
                  autoComplete='off'
                ></form>
              </div>
              <div className='nav-item pe-3 mb-1'>
                <form
                  data-kt-search-element='form'
                  className='w-100 mw-250px position-relative'
                  autoComplete='off'
                >
                  {/* <WSSelect placeholder='All campaigns' selectList={options} /> */}
                  <WSSelect
                    value={campType}
                    onChange={(e: any) => {
                      setCampType(e.value)
                    }}
                    placeholder='All campaigns'
                    options={options}
                  />
                </form>
              </div>
              <div className='d-flex'>
                <span
                  className='btn btn-sm btn-primary py-3 px-8'
                  onClick={() => navigate('/report-analytics/bulk-messages')}
                >
                  View all
                </span>
              </div>
            </div>
          </div>

          {isFetching ? (
            <div className='min-h-300px text-center'>
              <Spinner />
            </div>
          ) : data?.data?.items?.length > 0 ? (
            <div className='card-body pb-3 pt-7'>
              <div className='table-responsive'>
                <table className='table align-middle gs-0 gy-5'>
                  <thead>
                    <tr className='fw-400 text-muted '>
                      <th className='p-0 w-40px'>CAMPAIGN</th>
                      <th className='p-0 w-210px'></th>
                      <th className='p-0 min-w-150px ps-3'>SENT DATE</th>
                      <th className='p-0 min-w-40px ps-2'>RECIPIENTS</th>
                      <th className='p-0 min-w-40px ps-2'>STAGGER</th>
                      <th className='p-0 min-w-40px ps-2'>UNSUB</th>
                      <th className='p-0 min-w-40px ps-3'>CLICK THROUGH</th>
                      <th className='p-0 min-w-40px ps-2'>REPLIES</th>
                      <th className='p-0 min-w-40px ps-3'>STATUS</th>
                      <th className='p-0 min-w-40px ps-3'>Action</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.items?.map((key: any, i: number) => (
                      <tr className='border-dashed border-2 border-bottom' key={i}>
                        <th className=''>
                          <div className='symbol symbol-50px me-2'>
                            <span className='symbol-label'>
                              <span className='badge green_text_badge fs-7 badge-square p-4 w-50px h-50px'>
                                {key?.camp_type}
                              </span>
                            </span>
                          </div>
                        </th>
                        <td className=''>
                          {key?.name}

                          <span className='text-gray-400 fw-light p-0 d-block'>
                            Created {moment(key?.createdAt).format('l')}
                          </span>
                        </td>
                        <td>
                          {
                            <span className='text-dark fw-400  d-block mb-1 fs-6'>
                              {moment(key?.scheduleAt || key?.createdAt).format(
                                'MMMM DD, YYYY hh:mm A'
                              )}
                            </span>
                          }
                        </td>
                        <td>
                          <span className='text-dark fw-400  d-block mb-1 fs-6'>
                            {key?.staggerId && key?.totalRecipients
                              ? `${key?.completedRecipients}/${key?.totalRecipients}`
                              : key?.recipients}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-400  d-block mb-1 fs-6'>
                            {key?.staggerId && key?.totalRecipients
                              ? `${key?.completedCount} / ${
                                  key?.completedCount + key?.scheduledCount
                                }`
                              : '-'}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-400  d-block mb-1 fs-6'>{key?.unsub}</span>
                        </td>
                        <td>
                          <span className='text-dark fw-400  d-block mb-1 fs-6'>
                            {key?.clickThrough}
                          </span>
                        </td>
                        <td>
                          <span className='text-dark fw-400  d-block mb-1 fs-6'>
                            {key?.replies}
                          </span>
                        </td>

                        <td>
                          <span
                            className={`badge badge-light-${
                              key?.finalStatus?.toLowerCase() == 'completed' ? 'success' : 'warning'
                            } fw-bold`}
                          >
                            {getDisplayStatus(key)}
                          </span>

                          <div>
                            {(key?.canceledAt || key?.pausedAt) &&
                              moment(key?.canceledAt || key?.pausedAt).format(
                                'MMMM DD, YYYY hh:mm A'
                              )}
                          </div>
                        </td>
                        <td className='text-center'>
                          <>
                            {/* Show Detail Button */}
                            {
                              <OverlayTrigger
                                placement='bottom'
                                overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
                              >
                                <>
                                  <Link
                                    to={`${
                                      key?.finalStatus?.toLowerCase() !== 'scheduled'
                                        ? '/eofy/snapshot'
                                        : '/scheduler/snapshot'
                                    }`}
                                    target='_blank'
                                    onClick={() => {
                                      // Completed campaign
                                      if (key?.finalStatus?.toLowerCase() === 'completed') {
                                        dispatch(
                                          storeReportId({
                                            id: key?._id,
                                            camp_type: campType,
                                          })
                                        )

                                        return
                                      }

                                      if (key?.finalStatus?.toLowerCase() === 'scheduled') {
                                        dispatch(
                                          storeSchedulerId({
                                            id: key?._id,
                                            camp_type: campType,
                                          })
                                        )
                                        return
                                      }

                                      // In progress stagger campaign
                                      if (
                                        key?.staggerId &&
                                        key?.finalStatus?.toLowerCase() === 'in progress' &&
                                        key?.bulkId
                                      ) {
                                        dispatch(
                                          storeReportId({
                                            id: key?.bulkId,
                                            camp_type: campType,
                                          })
                                        )
                                        return
                                      }

                                      // Default state for running campaign
                                      dispatch(
                                        storeReportId({
                                          id: key?.bulkId ? key?.bulkId : key?._id,
                                          camp_type: campType,
                                        })
                                      )
                                    }}
                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrows/arr064.svg'
                                      className='svg-icon-2'
                                    />
                                  </Link>
                                </>
                              </OverlayTrigger>
                            }

                            {key?.finalStatus?.toLowerCase() !== 'completed' &&
                              !key?.canceledAt &&
                              !key?.pausedAt &&
                              key?._id && (
                                <>
                                  {/* Show pause and cancel normal campaign  when not scheduled */}
                                  {key?.finalStatus?.toLowerCase() !== 'scheduled' && (
                                    <>
                                      <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip id='button-tooltip'>Pause</Tooltip>}
                                      >
                                        <button
                                          className='btn btn-disable btn-sm btn-icon btn-bg-light btn-warning ms-3'
                                          onClick={() => {
                                            setPauseIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                            setCampaignType(campType)
                                            setIsOpenPauseConfirmation(true)
                                          }}
                                        >
                                          {pauseCampaignLoading &&
                                          [key?._id, key?.bulkId].includes(pauseIdParam) ? (
                                            <Spinner />
                                          ) : (
                                            <i className='bi bi-pause fs-5'></i>
                                          )}
                                        </button>
                                      </OverlayTrigger>

                                      <OverlayTrigger
                                        placement='top'
                                        overlay={<Tooltip id='button-tooltip'>Cancel</Tooltip>}
                                      >
                                        <button
                                          className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                          onClick={() => {
                                            setCancelIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                            setCampaignType(campType)
                                            setIsOpenCancelConfirmation(true)
                                          }}
                                        >
                                          {cancelCampaignLoading &&
                                          [key?._id, key?.bulkId].includes(cancelIdParam) ? (
                                            <Spinner />
                                          ) : (
                                            <i className='bi bi-x fs-5'></i>
                                          )}
                                        </button>
                                      </OverlayTrigger>
                                    </>
                                  )}

                                  {/* Show only cancel campaign when it scheduled */}
                                  {key?.finalStatus?.toLowerCase() === 'scheduled' && (
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={
                                        <Tooltip id='button-tooltip'>
                                          Cancel Schedule Campaign
                                        </Tooltip>
                                      }
                                    >
                                      <button
                                        className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                        onClick={() => {
                                          setCancelParam({
                                            id: key?.queueJobId,
                                            staggerMessages: key?.staggerMessages,
                                            staggerId: key?.staggerId,
                                            type: campType,
                                          })
                                          setIsOpenConfirmation(true)
                                        }}
                                        disabled={cancelLoading}
                                      >
                                        {cancelLoading ? (
                                          <Spinner />
                                        ) : (
                                          <i className='bi bi-x fs-5'></i>
                                        )}
                                      </button>
                                    </OverlayTrigger>
                                  )}
                                </>
                              )}

                            {key?.pausedAt && (
                              <>
                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip id='button-tooltip'>Resume</Tooltip>}
                                >
                                  <button
                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-info ms-3'
                                    onClick={() => {
                                      setResumeIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                      setCampaignType(campType)
                                      setSelectedBulk(key)
                                      setIsOpenResumeConfirmation(true)
                                    }}
                                  >
                                    {resumeCampaignLoading &&
                                    [key?._id, key?.bulkId].includes(resumeIdParam) ? (
                                      <Spinner />
                                    ) : (
                                      <i className='bi bi-arrow-clockwise fs-5'></i>
                                    )}
                                  </button>
                                </OverlayTrigger>

                                <OverlayTrigger
                                  placement='top'
                                  overlay={<Tooltip id='button-tooltip'>Cancel</Tooltip>}
                                >
                                  <button
                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                    onClick={() => {
                                      setCancelIdParam(key?.bulkId ? key?.bulkId : key?._id)
                                      setCampaignType(campType)
                                      setIsOpenCancelConfirmation(true)
                                    }}
                                  >
                                    {cancelCampaignLoading &&
                                    [key?._id, key?.bulkId].includes(cancelIdParam) ? (
                                      <Spinner />
                                    ) : (
                                      <i className='bi bi-x fs-5'></i>
                                    )}
                                  </button>
                                </OverlayTrigger>
                              </>
                            )}
                          </>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <InsertNewData
              message={{
                title: 'No recent campaigns (yet!)',
                subtitle:
                  "It looks like you haven't sent any messages yet, why don't you give it a try?",
              }}
              buttonName={{name: 'New message', link: '/new-message'}}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default DashbaordTablePage
